export function uuid(): number {
    const str = '' + Date.now() + Math.floor(Math.random()*99999);
    return (str as any) - 0; // convert to number
}
